// import { logger } from '@/util/logger';
import ResponsiveTable from '../modules/responsiveTable.js';
import { confirmToast } from '../modules/toast';

const $ = window.$;

export default function Feed(id, settings) {
	this.s = settings || {};
	// Extend Responsive Table Object
	ResponsiveTable.apply(this, [id, 'feed', settings]);

	// Save reference to this
	var that = this;

	// Feed Cached Selectors
	this.$categoryColumn;
	this.$expandableLists;
	this.$toggleDetailed;
	this.$enableEditing;
	this.$saveEdits;
	this.$editInputs;

	this.isSourceAndImageHidden = false;
	this.cancelExpand = false;


	this.isDetailedMode = this.$outer.hasClass('is-detailed-mode');
	// Row click event properties
	this.numRowClicks = 0;
	this.handleRowClickTimer = null;
	this.rowMouseDownTime;
	this.rowMouseXPos;
	this.rowMouseYPos;


	// **************************
	// Define Feed Methods
	// **************************

	this.cacheAdditionalSelectors = function() {
		this.$categoryColumn = this.$outer.find('.js-col-category');
		this.$expandableLists = this.$outer.find('.js-expandable-list');
		this.$editInputs = this.$outer.find('.js-edit-input');
		this.$toggleDetailed = this.$outer.find('.js-toggle-detailed');
		this.$enableEditing = this.$outer.find('.js-enable-editing');
		this.$saveEdits = this.$outer.find('.js-save-edits');
	};

	// these functions are called by the showColumn and hideColumn methods of responsiveTable
	this.afterShowColumn = function(col) {
		this.$outer.find('.js-expandable-' + col.header)
			.addClass('is-hidden');
	};

	this.afterHideColumn = function(col) {
		this.$outer.find('.js-expandable-' + col.header)
			.removeClass('is-hidden');
	};


	this.afterDistributeAvailableWidth = function() {
		// align expandable data to new column positions
		this.positionExpandableData();
	};



	this.toggleExpandableData = function($row) {
		// Don't toggle if there was more than 1 click in rapid succession
		if (this.numRowClicks < 2) {
			if ($row.hasClass('is-expanded')) {
				$row.removeClass('is-expanded');
				$row.find('.js-expand-icon').attr('src', 'images/icons-v2/carat-right-no-frame-20px.svg');
			} else {
				$row.addClass('is-expanded');
				$row.find('.js-expand-icon').attr('src', 'images/icons-v2/carat-down-no-frame-20px.svg');
			}
		}

		// Sometimes, if toggling a row causes a scrollbar to appear on the window, this will cause the cell width calculations
		// to be off, so reset them once the expandable data has been toggled
		this.sizeColumns(true);
		this.resetRowClick();
	};

	this.positionExpandableData = function() {
		// if category not visible, don't change default position of expandable data
		if (this.$categoryColumn.is(':visible')) {
			this.$expandableLists.css('padding-left', this.$categoryColumn.position().left + parseInt(this.$categoryColumn.css('padding-left')) - 2);
		} else {
			this.$expandableLists.css('padding-left', 28);
		}
	};


	this.normalizeSelectNames = function(newName) {
		this.$outer.find('.js-' + this.type + '-select').attr('name', newName);
	};

	this.toggleDetailedMode = function() {
		this.$outer.toggleClass('is-detailed-mode');
		this.$toggleDetailed.toggleClass('is-off');
		this.isDetailedMode = this.$outer.hasClass('is-detailed-mode');
		var prefWalletDetailedValue = this.isDetailedMode ? '1' : '0';

		// update translated tooltip
		if (this.isDetailedMode) {
			this.$toggleDetailed.attr('title', this.$toggleDetailed.data().tooltipOn);
		} else {
			this.$toggleDetailed.attr('title', this.$toggleDetailed.data().tooltipOff);
		}

		// set detailed mode preference
		$.ajax({
			type: 'POST',
			url: 'WalletService.aspx',
			data: { 'prefWalletDetailed': prefWalletDetailedValue },
			dataType: 'text',
		});

	};

	this.afterSort = function(isInit) {
		if (!isInit) return;
		var $highlightedRow = $('.js-feed-row.a-load-highlight');

		if ($highlightedRow.length) {
			$highlightedRow.addClass('a-load-highlight');
			window.animateLoadHighlight($highlightedRow);

			// if highlighted row exists and it moved out of view after sort, focus it back into view
			window.scrollJump.immediateJump($highlightedRow);
		}
	};

	this.enableEditMode = function() {
		// hide edit button
		this.$outer.addClass('is-edit-mode');

		// undisable edit fields
		this.$editInputs.prop('disabled', false);

		this.$enableEditing.addClass('is-hidden');
		this.$saveEdits.removeClass('is-hidden');

	};

	this.saveEdits = function() {
		var $editedRows = this.$outer.find('.js-has-edits');

		// disable editable fields
		this.$editInputs.prop('disabled', true);
		// hide save icon
		this.$saveEdits.addClass('is-off');

		// append spinny
		// this.$saveEdits.insertAfter(createProgressIndicator('progressindicatorid'))

		var editData = {};
		// do ajax post to save
		// build data structure to send by looping through rows and grabbing data-edited-details from rows with class js-has-edits

		window.applyLoadingState();

		// build data object
		$editedRows.each(function() {
			// strip any html characters that may have snuck their way in from trying to post to the server
			editData[this.getAttribute('data-rid')] = window.stripAllMarkup(this.getAttribute('data-js-edited-details'));
		});

		$.ajax({
			type: 'POST',
			url: 'WalletService.aspx',
			data: { 'editData': JSON.stringify(editData) },
			dataType: 'text',
		}).done(function(response) {
			// update details
			$editedRows.each(function() {
				var $this = $(this);
				var strEditedDetails = this.getAttribute('data-js-edited-details') || this.getAttribute('data-default-details');
				$this.find('.js-edit').text(strEditedDetails);
				$this.find('.js-edit-input')
					.attr('data-initial-value', strEditedDetails)
					.val(strEditedDetails);
				$this.removeClass('js-has-edits')
					.removeAttr('data-edited-details');
			});

			//logger.log('success');
			confirmToast.show(response);
		})
			.fail(function() {
				//logger.log('fail');
			})
			.always(function() {
				window.removeLoadingState();
				that.$outer.removeClass('is-edit-mode');
				that.$enableEditing.removeClass('is-hidden');
				that.$saveEdits
					.removeClass('is-off')
					.addClass('is-hidden');
			});

	};

	this.saveEditsDebounced = window.debounce(this.saveEdits, 250);

	this.resetRowClick = function() {
		clearTimeout(this.handleClickTimer);
		this.delayRowExpand = false;
		this.numRowClicks = 0;
	};

	this.handleRowClick = function($row, e) {
		var diffX = Math.abs(that.rowMouseXPos - e.screenX);
		var diffY = Math.abs(that.rowMouseYPos - e.screenY);
		var time = Date.now();

		// Cancel click if we clicked on a target that should not cause an expand
		if (this.cancelExpand) {
			this.cancelExpand = false;
			return;
		}

		// Cancel click event if mouse was held down longer than 500ms
		if (time - that.rowMouseDownTime > 500) return;

		// Cancel the click event if mouse moved more than 100px
		if ((diffX + diffY) > 100) return;

		if (this.delayRowExpand) {
			// clear a running timer if there is one
			clearTimeout(that.handleRowClickTimer);

			// start a new cancellable toggle event
			this.handleRowClickTimer = setTimeout(function() {
				that.toggleExpandableData($row);
			}, 200);

			this.numRowClicks++;

			return;
		}

		this.toggleExpandableData($row);
	};

	this.updateDetailsValues = function($input) {
		var $row = $input.parents('.js-' + this.type + '-row');
		var val = window.stripAllMarkup($input.val());

		if (val.length < $input.val().length) {
			// update val if characters were stripped
			$input.val(val);
		}

		if (val !== $row.attr('data-initial-value')) {
			$row
				.addClass('js-has-edits')
				.attr('data-js-edited-details', val);
		} else {
			$input.parents('.js-' + this.type + '-row')
				.removeClass('js-has-edits')
				.attr('data-js-edited-details', val);
		}
	};

	this.updateDetailsValuesDebounced = window.debounce(this.updateDetailsValues, 250);

	this.beforeInit = function(context) {
		// reset attached events so they don't get reattached.

		context.$outer.off('.feed');
		$(document).off('.feed');

		// If using a normalized select name, apply it here.
		if (context.s.selectName) {
			context.normalizeSelectNames(context.s.selectName);
		}
	};

	this.afterInit = function(context) {
		// Once DOM is fully loaded do sizing/positioning of wallet body
		context.positionExpandableData();

		context.$outer.on('mousedown', '.js-expand', function(e) {
			if (this.isDetailedMode) return;

			var $target = $(e.target);
			var nodeName = e.target.nodeName;

			context.rowMouseDownTime = Date.now();
			context.rowMouseXPos = e.screenX;
			context.rowMouseYPos = e.screenY;

			if ($target.hasClass('js-modal-open') || nodeName === 'INPUT' || $target.hasClass('js-edit') || $target.parent().hasClass('js-edit') || $target.hasClass('feed_edit-item')) {
				context.cancelExpand = true;
				return;
			}

			if (context.$outer.find('.js-col-category').is(':visible')) {
				// While category is visible...

				// We don't want to toggle the row on double click if we are hovering over text
				if (nodeName === 'SPAN') {
					context.delayRowExpand = true;
					return;
				}
			}
		});

		// ********************************
		// Global Events
		// ********************************
		context.$outer
			.on('click.feed', '.js-edit', function() {
				context.enableEditMode();

				$(this).siblings('.js-edit-input').focusWithoutScrolling();
			})
			.on('click.feed', '.js-expand', function(e) {
				if (this.isDetailedMode) return;

				context.handleRowClick($(this), e);
			})
			.on('keydown.feed', '.js-edit-input', function(e) {
				if (window.isEnterKey(e)) {
					context.saveEditsDebounced();
					e.preventDefault();
					return false;
				}
			})
			.on('keyup.feed change.feed', '.js-edit-input', function(e) {
				var $this = $(this);
				// validate that the value is different from initial value

				if (e.type === 'keyup') {
					context.updateDetailsValuesDebounced($this);
				} else {
					context.updateDetailsValues($this);
				}
			})
			.on('click.feed-edit', '.js-enable-editing', function() {
				context.enableEditMode();
				context.$editInputs.first().focusWithoutScrolling();
			})
			.on('click.feed-edit', '.js-save-edits', function() {
				if ($(this).hasClass('is-off')) return;
				context.saveEdits();
			})
			.on('click.feed-edit', '.js-toggle-detailed', function() {
				context.toggleDetailedMode();
			});
	}; // end after init

}


// define wallet column data. Passed to Feed/Responsive Table object in codebehind when page is rendered
window.feedColumns = [
	{ 'header': 'select', 'fixed': true },
	{ 'header': 'source', 'fixed': true },
	{ 'header': 'image', 'fixed': true },
	{ 'header': 'date', 'fixed': true },
	{ 'header': 'category', 'minWidth': 125, 'priority': 2 },
	{ 'header': 'vendor', 'minWidth': 125, 'priority': 3 },
	{ 'header': 'reason', 'minWidth': 120, 'priority': 1 },
	{ 'header': 'amount', 'fixed': true }
];

window.feedMiniColumns = [
	{ 'header': 'action', 'fixed': true },
	{ 'header': 'source', 'fixed': true },
	{ 'header': 'image', 'fixed': true },
	{ 'header': 'date', 'fixed': true},
	{ 'header': 'category', 'minWidth': 90, 'priority': 3 },
	{ 'header': 'reason', 'minWidth': 72, 'priority': 2 },
	{ 'header': 'amount', 'fixed': true }
];